import { brandMeta } from "@/mocks/content";

export default function Hero() {
  return (
    <section
      id="top"
      className="relative overflow-hidden bg-gradient-to-br from-rose-50 via-[#fff6ec] to-emerald-50"
    >
      {/* 背景装饰圆点 */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -top-24 -right-16 h-72 w-72 rounded-full bg-gradient-to-br from-rose-200/50 to-orange-200/50 blur-2xl"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -bottom-20 -left-16 h-72 w-72 rounded-full bg-gradient-to-br from-emerald-200/50 to-teal-100/50 blur-2xl"
      />

      <div className="relative mx-auto grid max-w-6xl items-center gap-10 px-4 md:px-6 py-16 md:py-24 lg:grid-cols-[1.05fr_1fr]">
        <div className="animate-fade-up text-center lg:text-left">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/80 px-4 py-1.5 text-sm font-medium text-rose-600 ring-1 ring-rose-200">
            <i className="ri-fire-line" aria-hidden="true" />
            互联网流行语 · 吃瓜文化科普
          </span>

          <h1 className="mt-5 font-heading text-4xl leading-tight text-stone-800 sm:text-5xl md:text-[3.4rem]">
            53吃瓜 <span className="text-rose-500">是什么</span>？
          </h1>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-stone-600 sm:text-lg">
            从<span className="font-medium text-stone-800">“53吃瓜”到“五三吃瓜”</span>
            ，这个梗到底什么意思、又是怎么火起来的？本文一次讲清它的出处、含义拆解与日常用法，让你快速跟上吃瓜圈的聊天节奏，
            不再看不懂评论区在说什么。
          </p>

          <div className="mt-7 flex flex-col items-center gap-3 sm:flex-row lg:justify-start justify-center">
            <a
              href="#meaning"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-rose-500 px-6 py-3 text-sm font-medium text-white transition-colors hover:bg-rose-600 sm:w-auto"
            >
              5 分钟搞懂含义
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </a>
            <a
              href="#glossary"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-white/90 px-6 py-3 text-sm font-medium text-stone-700 ring-1 ring-stone-200 transition-colors hover:bg-white sm:w-auto"
            >
              <i className="ri-book-open-line" aria-hidden="true" />
              查吃瓜黑话词典
            </a>
          </div>

          <p className="mt-6 text-xs text-stone-400">
            本站由 {brandMeta.name} 整理 · 内容为圈内通行解读，欢迎补充纠正
          </p>
        </div>

        {/* 首屏插图 */}
        <div className="relative mx-auto w-full max-w-md">
          <div className="animate-floaty relative overflow-hidden rounded-[2rem] shadow-soft ring-1 ring-white/60">
            <img
              src="https://readdy.ai/api/search-image?query=playful%20flat%20vector%20illustration%20of%20a%20happy%20crowd%20of%20young%20netizens%20watching%20a%20giant%20slice%20of%20watermelon%20that%20plays%20video%20content%20like%20a%20screen%2C%20floating%20chat%20speech%20bubbles%20and%20hot%20topic%20tags%20around%2C%20warm%20cream%20background%2C%20coral%20red%20and%20mint%20green%20and%20orange%20color%20palette%2C%20clean%20minimal%20modern%20internet%20culture%20meme%20style&width=900&height=900&seq=hero-chigua-53-01&orientation=squarish"
              alt="53吃瓜含义科普插画，一群网友围着巨型西瓜看热闹"
              title="53吃瓜含义插画"
              className="h-auto w-full object-cover"
            />
          </div>
          <div className="animate-wiggle absolute -bottom-4 -left-4 rounded-2xl bg-white px-4 py-2.5 shadow-soft ring-1 ring-orange-100">
            <p className="text-sm font-medium text-stone-700">蹲一个后续 🍉</p>
          </div>
          <div className="animate-floaty absolute -top-4 -right-3 rounded-2xl bg-emerald-500 px-4 py-2.5 text-white shadow-soft">
            <p className="text-sm font-medium">前排吃瓜中</p>
          </div>
        </div>
      </div>

      {/* 跑马灯关键词 */}
      <div className="relative border-t border-white/60 bg-white/40 py-3 backdrop-blur-sm">
        <div className="overflow-hidden">
          <div className="animate-marquee flex w-max gap-10 whitespace-nowrap text-sm font-medium text-stone-500">
            {Array(2)
              .fill(0)
              .map((_, k) => (
                <span key={k} className="flex items-center gap-10">
                  {["53吃瓜是什么", "五三吃瓜含义", "吃瓜梗的由来", "黑话词典", "吃瓜群众", "蹲后续", "实锤", "反转"].map(
                    (t) => (
                      <span key={t} className="flex items-center gap-10">
                        <span>{t}</span>
                        <i className="ri-eye-line text-rose-400" aria-hidden="true" />
                      </span>
                    )
                  )}
                </span>
              ))}
          </div>
        </div>
      </div>
    </section>
  );
}